import { render, staticRenderFns } from "./AnalyticsInventoryNew.vue?vue&type=template&id=40366026"
import script from "./AnalyticsInventoryNew.vue?vue&type=script&lang=js"
export * from "./AnalyticsInventoryNew.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsInventoryNew.vue?vue&type=style&index=0&id=40366026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports